import { render, staticRenderFns } from "./UpdateStock.vue?vue&type=template&id=3e5f4387&scoped=true"
import script from "./UpdateStock.vue?vue&type=script&lang=js"
export * from "./UpdateStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5f4387",
  null
  
)

export default component.exports